import type { LucideIcon } from 'lucide-react';
import type { Range } from './match';
import type { RecentEntry } from './recent';
import type { SnippetPart } from './snippet';

export type ResultGroup = 'tickets' | 'tasks' | 'wiki' | 'people';

export type PaletteGroup =
  | 'recent'
  | 'mytasks'
  | 'commands'
  | 'nav'
  | 'create'
  | 'admin'
  | 'prefs'
  | 'account'
  | ResultGroup
  | 'more';

export interface PaletteItem {
  id: string;
  group: PaletteGroup;
  kind: RecentEntry['kind'] | 'more';
  icon: LucideIcon;
  label: string;
  ranges?: Range[];
  badge?: string;
  subtitle?: string;
  snippet?: SnippetPart[];
  hint?: string;
  status?: { label: string; open: boolean; ticketStatus?: string };
  person?: { seed: string };
  details?: { label: string; value: string }[];
  description?: string;
  to?: string;
  run?: () => void;
  stay?: boolean;
  removable?: boolean;
}

export type SearchResults = Record<ResultGroup, PaletteItem[]>;

export const EMPTY_RESULTS: SearchResults = { tickets: [], tasks: [], wiki: [], people: [] };
